// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0{fill:#005493}.st1{fill:#4cd3d4}.st2{fill:#76d6ff;enable-background:new}.st3{fill:#fff}.v-avatar{padding:5px}", ""]);
// Exports
module.exports = exports;
